import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'
import { useHoverState } from '../../hooks/useHoverState'

import './style.scss'

const colorToColorDetails = (
  color
) => {
  switch (color) {
    case 'white':
      return {
        normal: '#FFFFFF',
        hover: '#BFBFBF'
      }
    case 'grey':
    case 'gray':
      return {
        normal: '#A2B3B8',
        hover: '#697478'
      }
    case 'link':
      return {
        normal: '#2c9ab7',
        hover: '#52bad5'
      }
    default:
      return {
        normal: color,
        hover: color
      }
  }
}

export default React.forwardRef(function MUIIcon ({
  component: IconComponent,
  color="white", // Color
  clickable = true, // Show cursor
  disabled = false, // Disabled color
  colorDetails = null, // Provide custom normal and hover colors
  ...props
}, forwardRef) {
  const [ref, isHovered] = useHoverState({ forwardRef })

  const className = [
    'app-mui-icon',
    (clickable && !disabled) ? 'clickable' : null
  ]
  .filter(name => name)
  .join(' ')

  const currentColorDetails = colorDetails || colorToColorDetails(color)
  const currentColor = isHovered && clickable
    ? (currentColorDetails.hover || currentColorDetails.normal)
    : currentColorDetails.normal

    if (typeof IconComponent === 'string') throw new Error('Invalid component prop - string icons not supported due to tree shaking requirements');

  return (
    <SvgIcon
      color={disabled ? 'disabled' : undefined}
      htmlColor={currentColor}
      className={className}
      {...props}
      ref={ref}
    >
      <IconComponent />
    </SvgIcon>
  )
})